export default __webpack_public_path__ + "static/media/totalFuentesEfectivo.346ee5d1.svg";